import React, { useEffect, useState } from "react";
import CourseService from "../../../helper/services/course-service";
import ShCourseFullCard from "../../../page-components/course-card/shCourseFull.card";

const CourseCard = ( { courseId } ) => {

    const [ course, setCourse ] = useState(null);

    useEffect(
        () => {
            const action = async () => {
                const courseService = new CourseService();
                const courses = await courseService.fetchCoursesSliderList(false);

                const course = courses.find( c => c.id === courseId);
                setCourse(course);

            };
            action();
        },
        []
    );


    if (!course) {
        return null;
    }

    return <div className="mw-card">
        <ShCourseFullCard course={course} />
    </div>;

};

export default CourseCard;
